// extracted by mini-css-extract-plugin
export default {"rating":"rM-z","numberOfStars":"sM-z","count":"tM-z","barGraphSpacing":"uM-z","barGraph":"vM-z"};